import "./MandateCommand.module.css";
import Header from "@/reusable_sections/Header";
import MandatHero from "./sections/MandatHero";
import DocumentsSection from "./sections/DocumentsSection";
import Footer from "@/reusable_sections/Footer";
export default function MandateCommandPage() {
  return <div>
      <Header />
      <MandatHero />
      <DocumentsSection />
      <Footer />
    </div>;
}